// extracted by mini-css-extract-plugin
module.exports = {"newBg":"TrafficMessageRoutesText_newBg_2dBxM"};